import { Box, styled } from '@mui/material';

import { getAssetPath } from '@/constants/configs';

export const Logo = styled(
  (props?: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img src={getAssetPath('/logo-with-text.svg')} alt="logo" {...props} />
  ),
)(({ theme }) => ({
  margin: `${theme.spacing(6)} auto ${theme.spacing(8)}`,
  width: 206,
  [theme.breakpoints.up('lg')]: {
    margin: `${theme.spacing(8)} auto ${theme.spacing(12)}`,
  },
}));

export const LogoFinished = styled(props => (
  <img
    src={getAssetPath('/logo-with-text-white.svg')}
    {...props}
    alt="finish-logo-in-white-text"
  />
))(({ theme }) => ({
  marginBottom: theme.spacing(46),
  width: 248,
}));

export const CaymanCountryLogoWithText = styled(
  (
    props: React.ImgHTMLAttributes<HTMLImageElement> & {
      'data-test-id'?: string;
    },
  ) => (
    <img
      src={getAssetPath('/cayman-logo-with-text.svg')}
      alt={props.alt ?? 'Cayman Country Logo with Text'}
      width={props.width ?? 248}
      style={props.style}
      data-test-id={props['data-test-id']}
      {...props}
    />
  ),
)();

export const CaymanLogo = styled(
  (
    props: React.ImgHTMLAttributes<HTMLImageElement> & {
      'data-test-id'?: string;
    },
  ) => (
    <img
      src={getAssetPath('/cayman-logo.svg')}
      alt={props.alt ?? 'Cayman Country Logo'}
      width={props.width ?? 248}
      style={props.style}
      data-test-id={props['data-test-id'] ?? 'cayman-country-logo'}
      {...props}
    />
  ),
)();

export const LogoContainerResponsive = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));

export default Logo;
